<template>
  <div class="switch-map-btn">
    <div class="top-j">
    <span style="display: none">{{path}}</span>
    </div>
    <a href="javascript:;" class="btn-content" @click="change">
      <i class="iconfont icon-you"></i>
      {{isMap ? '切换到表格' : '切换到地图'}}
    </a>
    <div class="bottom-j">
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        isMap: false
      }
    },
    props: ['mapPathName'],
    methods: {
      change () {
        this.isMap ? this.$router.go(-1) : this.$router.push({name: this.mapPathName})
      }
    },
    computed: {
      path: {
        get () {
          this.isMap = this.$store.state.route.name === 'cycle' || this.$store.state.route.name === 'single' || this.$store.state.route.name === 'tobacco' || this.$store.state.route.name === 'single.single'
          return this.$store.state.route.path
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .switch-map-btn {
    z-index: 20;
    position: fixed;
    display: flex;
    top: 20rem;
    right: 0;
    width: 1.9em;
    flex-direction:column;
    line-height: 1.1;
  }
  .icon-qiehuan3:before { content: "\e61d"; }
  .top-j {
    flex: 1;
    width: 0;
    height: 0;
    border-bottom: 0.81em solid #486881;
    border-left: 1.88em solid transparent; 
  }
  .bottom-j {
    flex: 1;
    width: 0;
    height: 0;
    border-top: 0.81em solid #486881;
    border-left: 1.88em solid transparent; 
  }
  .btn-content {
    padding: 3px 0;
    background-color: #486881;
    text-align: center;
    color: #fff;
    font-size: 1em;
    i {
      line-height: 1.3;
      font-size: 1.4em;
    }
  }
</style>



// WEBPACK FOOTER //
// SwitchMapBtn.vue?0ba50146